<template>
  <div class="mediaReference">
    <label class="v-label theme--light caption" :class="{ 'error--text': !valid }"
      >{{ label }} <span v-if="required">*</span></label
    >
    <div class="mediaReference-box grey lighten-3 pa-3" :class="{ error: !valid }">
      <div>
        <span>
          <v-icon small>link</v-icon>
          <a href="" @click.prevent="openBrowser">{{ labelSelectMedia }}</a>
        </span>
        <div></div>
        <span v-if="canAdd">
          <v-icon small>add</v-icon>
          <a href="" @click.prevent="addNewMedia" class="mr-3">{{ labelAddMedia }}</a>
        </span>
      </div>
      <div>
        <template v-for="(i, index) in icons">
          <v-icon :key="index">{{ i }}</v-icon>
        </template>
      </div>
    </div>
    <div class="error--text caption" v-if="!this.valid">Campo obbligatorio</div>
    <div class="caption v-label theme--light pt-2" v-if="this.hint">{{ hint }}</div>
    <v-list v-if="referencedMedia.length" two-line>
      <draggable v-model="referencedMedia" handle=".drag" @change="moved">
        <transition-group type="transition" name="flip-list">
          <v-list-tile :key="m.public_id" avatar three-line v-for="(m, index) in referencedMedia">
            <v-icon
              class="drag mr-2"
              handle
              v-if="referencedMedia.length > 1"
              title="Trascina per riordinare"
              >drag_indicator</v-icon
            >
            <v-list-tile-avatar size="60">
              <cloudinary-image
                v-if="m.resource_type === 'image' || m.resource_type === 'video'"
                :id="m.public_id"
                :type="m.resource_type"
                :version="m.version"
                transformation="h_120,w_120,q_auto,f_jpg,g_faces:center,c_fill"
              />
              <v-icon v-else class="grey lighten-1 white--text">attach_file</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content class="pl-2">
              <v-list-tile-title>{{ m.title }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ m.description }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-tooltip left v-if="$userHasRoles(['media'])">
                <v-btn
                  slot="activator"
                  icon
                  ripple
                  class="showMedia"
                  @click="goToMediaRoute(m._id)"
                >
                  <v-icon color="primary">remove_red_eye</v-icon>
                </v-btn>
                <span>Mostra il media collegato</span>
              </v-tooltip>
              <v-tooltip left>
                <v-btn slot="activator" icon ripple @click="removeMedia(index)">
                  <v-icon color="error">delete</v-icon>
                </v-btn>
                <span>Rimuovi il media</span>
              </v-tooltip>
            </v-list-tile-action>
          </v-list-tile>
        </transition-group>
      </draggable>
    </v-list>
    <!-- browse dialog -->
    <v-dialog v-model="browseDialog" max-width="800" scrollable @keydown.prevent.enter="search">
      <v-card>
        <v-toolbar class="title grey lighten-2" flat>
          <v-toolbar-title> Inserisci media esistenti </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeBrowser">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="height: 800px">
          <!-- ricerca -->
          <v-container fluid grid-list-lg>
            <v-form>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="q"
                    clearable
                    clear-icon="undo"
                    label="Cerca..."
                    type="text"
                    @input="search"
                  />
                </v-flex>
              </v-layout>
            </v-form>
            <v-layout row wrap>
              <v-flex v-for="(m, index) in mediaList" :key="index" xs12 sm6 md4>
                <search-media-card
                  :media="m"
                  :selected="isSelected(m)"
                  @media:selected="mediaSelected"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex class="mt-1" xs12 column justify-center>
                <v-btn
                  @click="loadMore()"
                  outline
                  class="ml-0 mt-4"
                  color="secondary"
                  v-if="total > mediaList.length"
                  ><v-icon small>add</v-icon> Mostra di più</v-btn
                >
                <v-alert
                  :value="mediaList.length && mediaList.length < total"
                  color="info"
                  icon="info"
                  outline
                  class="mt-4"
                >
                  Caricati tutti i media, {{ total }} in totale
                </v-alert>
                <v-alert :value="!mediaList.length" color="info" icon="info" outline>
                  Nessun media trovato
                </v-alert>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions v-show="multiple">
          <v-btn :disabled="!selected.length" @click="addMultipleMedia" class="primary">
            Aggiungi ({{ selected.length }})</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- uploader -->
    <media-upload
      :show="add"
      :type="type"
      :multiple="multiple"
      @close="add = false"
      @uploaded="AddNewUploadedMedia"
    />
  </div>
</template>

<script>
import { $EventBus } from '@/eventBus';
import _differenceBy from 'lodash/differenceBy';
import _union from 'lodash/union';
import _difference from 'lodash/difference';
import _debounce from 'lodash/debounce';
import mediaUpload from '@/components/media/MediaUpload';
import searchMediaCard from '@/components/media/SearchMediaCard';
import cloudinaryImage from '@/components/common/CloudinaryImage';
import draggable from 'vuedraggable';
import { $cloudinaryUrl } from '@/mixins/cloudinary';

export default {
  props: {
    value: {
      // list of media (model)
      type: Array,
    },
    label: {
      // etichetta campo
      type: String,
      required: true,
    },
    hint: {
      // help text campo
      type: String,
    },
    type: {
      // tipo: immagine, video o raw
      type: Array, // ['image', 'video']
      required: true,
      validator: (v) => _difference(['image', 'video', 'raw', 'pdf'], v).length === 4 - v.length,
    },
    required: {
      // se l'utente deve inserire per forza un valore
      type: Boolean,
    },
    multiple: {
      // se accetta valori multipli
      type: Boolean,
    },
    maxItems: {
      // numero massimo di valori
      type: Number,
    },
  },
  data: () => ({
    referencedMedia: [],
    add: false,
    browseDialog: false,
    mediaList: [],
    selected: [],
    total: null,
    valid: true,
    perPage: 18,
    page: 1,
    limit: 10,
    q: null, // chiave di ricerca
  }),
  components: {
    mediaUpload,
    searchMediaCard,
    cloudinaryImage,
    draggable,
  },
  mixins: [$cloudinaryUrl],
  computed: {
    resourceType() {
      return this.type.map((t) => {
        if (t === 'pdf') {
          t = 'raw'; // per cloudinary i pdf sono immagini
        }
        return t;
      });
    },
    icons() {
      const icons = [];
      if (this.type.includes('image')) {
        icons.push('camera_alt');
      }
      if (this.type.includes('video')) {
        icons.push('videocam');
      }
      if (this.type.includes('pdf') || this.type.includes('raw')) {
        icons.push('attach_file');
      }
      return icons;
    },
    canInsertMore() {
      // può referenziarne ancora?
      return this.maxItems ? this.referencedMedia.length < this.maxItems : true;
    },
    canAdd() {
      // se può aggiungere elementi nel media menager
      // Se si tratta di media immagine/video, verifico che il ruolo sia corretto
      // Altrimento sono allegati, quindi lascio caricare anche senza il ruolo media
      return _difference(['image', 'video'], this.type).length < 2
        ? this.$userHasRoles(['media'])
        : true;
    },
    labelSelectMedia() {
      return this.$t('media.sfoglia');
    },
    labelAddMedia() {
      // const labels = [];
      // if (this.type.includes('image')) {
      //   labels.push(`immagin${this.multiple ? 'i' : 'e'}`);
      // }
      // if (this.type.includes('video')) {
      //   labels.push('video');
      // }
      // if (this.type.includes('pdf')) {
      //   labels.push('pdf');
      // }
      // if (this.type.includes('raw')) {
      //   labels.push(`file${this.multiple ? 's' : ''}`);
      // }
      return this.$t('media.carica');
    },
  },
  methods: {
    cantAddMoreMessage() {
      $EventBus.$emit('message', {
        type: 'warning',
        text: `Puoi aggiungere al massimo ${this.maxItems} files`,
      });
    },
    addNewMedia() {
      if (this.canInsertMore) {
        this.add = true;
      } else {
        this.cantAddMoreMessage();
      }
    },
    getMedia(loadMore) {
      return new Promise((resolve, reject) => {
        const searchData = this.q ? [this.q] : null;
        const params =
          {
            q: searchData,
            page: this.page,
            limit: this.limit,
            proprietary: this.$user.email,
          } || {};
        if (this.type.includes('pdf')) {
          params.format = 'pdf'; // sottoinsieme delle immagini
        }
        this.resourceType.forEach((t) => {
          params[`resource_${t}`] = 1;
        });
        this.$http({
          method: 'GET',
          url: '/media/',
          params: params,
        })
          .then((response) => {
            this.total = response.data.total;
            if (!loadMore) {
              this.mediaList = response.data.items; // lista
            } else {
              this.mediaList = _union(this.mediaList, response.data.items); // appendi
            }
            resolve();
          })
          .catch((err) => {
            reject(err);
            $EventBus.$emit('message', { type: 'error', text: 'Impossibile recuperare i media' });
          });
      });
    },
    loadMore() {
      this.page += 1;
      this.getMedia(true);
    },
    openBrowser() {
      if (this.canInsertMore) {
        this.selected = []; // reset all'open
        this.page = 1;
        this.q = null;
        this.getMedia()
          .then((result) => {
            this.browseDialog = true;
          })
          .catch((err) => {
            console.log(err);
            $EventBus.$emit('message', { type: 'error', text: 'Impossibile recuperare i media' });
          });
      } else {
        this.cantAddMoreMessage();
      }
    },
    closeBrowser() {
      this.browseDialog = false;
    },
    mediaSelected(mediaSelected) {
      if (!this.multiple) {
        this.selected = [mediaSelected]; // sempre uno solo
        this.addSelectedMedia(); // aggiungi subito
      } else {
        // decidi quali sono e attendi il click per aggiornare il model
        const selectedIndex = this.selected.findIndex(
          (media) => media.public_id === mediaSelected.public_id,
        );
        if (selectedIndex !== -1) {
          // c'è già, toglilo
          this.selected.splice(selectedIndex, 1);
        } else {
          // altrimenti aggiungilo
          this.selected.push(mediaSelected);
        }
      }
    },
    isSelected(media) {
      return this.selected.findIndex((m) => m.public_id === media.public_id) !== -1;
    },
    addSelectedMedia() {
      // gestisce l'aggiunta dei media selezionati in base al tipo di campo
      const selectedExcludingInserted = _differenceBy(
        this.selected,
        this.referencedMedia,
        (i) => i._id,
      ); // non rimetto quelli già messi
      if (!selectedExcludingInserted.length) {
        $EventBus.$emit('message', { type: 'info', text: 'Nessun nuovo media da inserire' });
        this.closeBrowser();
      } else {
        let newMedia = selectedExcludingInserted;
        if (this.multiple) {
          newMedia = (this.value ? this.value : []).concat(selectedExcludingInserted); // multiplo: concatena (se vuoto inizializza)
        }
        if (newMedia.length > this.maxItems) {
          this.cantAddMoreMessage();
        } else {
          this.referencedMedia = newMedia;
          this.closeBrowser();
          this.$emit('input', this.referencedMedia);
          if (selectedExcludingInserted.length < this.selected.length) {
            $EventBus.$emit('message', {
              type: 'info',
              text: 'Alcuni media erano già stati inseriti',
            });
          }
        }
      }
    },
    removeMedia(index) {
      this.referencedMedia.splice(index, 1);
      this.value.splice(index, 1);
      this.$emit('input', this.referencedMedia);
    },
    moved(e) {
      this.$emit('input', this.referencedMedia);
    },
    AddNewUploadedMedia(mediaUploaded) {
      // dopo un nuovo upload
      this.selected = mediaUploaded;
      this.addSelectedMedia();
    },
    addMultipleMedia() {
      // aggiunta di media multipli dalla finestra di selezione
      this.addSelectedMedia();
    },
    validField() {
      if (!this.referencedMedia.length && this.required) {
        // errore capo richiesto
        this.valid = false;
        this.$emit('mediareference:invalid', 'il campo è obbligatorio');
      } else {
        this.$emit('mediareference:valid', this.referencedMedia);
        this.valid = true;
      }
    },
    search: _debounce(function (val) {
      this.page = 1;
      this.getMedia();
    }, 500),
    goToMediaRoute(mediaId) {
      const route = this.$router.resolve({ name: 'mediaItem', params: { id: mediaId } }).href;
      window.open(route, '_blank');
    },
  },
  watch: {
    referencedMedia: function (medias) {
      this.validField();
    },
  },
  mounted() {
    if (this.value) {
      // aggiorna i media già referenziati
      this.referencedMedia = this.value;
      this.validField();
    }
  },
};
</script>

<style scoped>
[handle]:hover {
  cursor: move !important;
}

.flip-list-move {
  transition: transform 0.5s !important;
}
.mediaReference {
  padding-top: 12px; /* usa la stessa spaziatura degli input di vuetify */
  margin-bottom: 24px;
}
.mediaReference-box {
  display: flex;
  justify-content: space-between;
}
.showMedia a {
  text-decoration: none;
}
</style>
